export default __webpack_public_path__ + "static/media/cocina.585a78c4.jpg";